export default __webpack_public_path__ + "57fbaf7a7bbab03f46d0ca7fddf3f718.svg";